/**
 * Landing page of the Okta callback. See complete-login.ts for the logic.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { appConfigQueryKey } from '@/shared/config/app-config';
import { hardNavigate } from '@/shared/lib/navigation';
import { completeLogin } from './complete-login';

export function AuthAdPage() {
  const queryClient = useQueryClient();
  useEffect(() => {
    let cancelled = false;
    void completeLogin().then((target) => {
      if (cancelled) return;
      void queryClient.invalidateQueries({ queryKey: appConfigQueryKey });
      hardNavigate(target);
    });
    return () => {
      cancelled = true;
    };
  }, [queryClient]);

  return <p className="p-4 text-sm text-neutral-600">Signing in…</p>;
}
